import { Injectable } from '@angular/core';
import { ActivatedRoute, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,private route: ActivatedRoute) {}

  async canActivate(route: any): Promise<boolean> {
    // Check if the user token is present
    const token = localStorage.getItem('romaPizza_token')?.toString();
    // If no token, redirect to login page
    if (!token) {
      // console.log(token)
      if(route.url[0].path.includes('sign-in') || route.url[0].path.includes('sign-up')){
        return true;
      }
      this.router.navigate(['/']);
      return false;
    }else if(token){
      console.log(route.url[0].path)
      if(route.url[0].path.includes('sign-in') || route.url[0].path.includes('sign-up')){
        this.router.navigate(['/']);
      }
    }
  }
}
